import { Storage } from 'aws-amplify';
import * as api from '../_api';

// @ts-ignore
export const create = async ({ dispatch }, one) => {
  try {
    await api.create(one);
    dispatch('snackbar/success', 'Angebot wurde erstellt', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const read = async ({ commit, dispatch }) => {
  try {
    const all = await api.read();
    commit('setAll', all);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const readOne = async ({ commit, dispatch }, { id }) => {
  try {
    const one = await api.readOne(id);
    commit('setOne', one);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const update = async ({ dispatch }, one) => {
  try {
    await api.update(one);
    dispatch('snackbar/success', 'Änderungen wurden gespeichert', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const remove = async ({ dispatch }, { id }) => {
  try {
    await api.remove(id);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const uploadImage = async ({ dispatch }, image) => {
  try {
    const newName = `${Math.random().toString(36).substr(2, 20)}${Math.random().toString(36).substr(2, 20)}`;
    await Storage.put(`offers/full/${newName}.${image.name.split('.').pop()}`, image);
    return `/offers/full/${newName}.${image.name.split('.').pop()}`;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const articleClickedBy = async ({ commit, dispatch }, article) => {
  try {
    const clickedBy = await api.articleClickedBy(article);
    commit('setClickedBy', {article, clickedBy: clickedBy.data});
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const setNewArticle = async ({ commit }, newArticle) => {
  commit('setNewArticle', newArticle);
};
